var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrrowLeftFromBracket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.1 8.9",
    width: 10.1,
    height: 8.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Button_icon",
    "data-name": "Button Icon",
    d: "M.1,4.8c-.2-.2-.2-.5,0-.7L2.7,1.6c.2-.2.5-.2.7,0s.2.5,0,.7l-1.7,1.7h4.9c.3,0,.5.2.5.5s-.2.5-.5.5H1.6l1.7,1.7c.2.2.2.5,0,.7s-.5.2-.7,0L.1,4.8ZM6.8.9c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h1.6c1,0,1.7.8,1.7,1.7v5.4c0,1-.8,1.7-1.7,1.7h-1.6c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h1.6c.4,0,.8-.4.8-.8V1.7c0-.4-.4-.8-.8-.8h-1.6Z",
    fill: "#52576a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowLeftFromBracket);
export default __webpack_public_path__ + "static/media/arrrow_left_from_bracket.4a76f18146694afc129ac57fa91c21df.svg";
export { ForwardRef as ReactComponent };